<template>
  <v-container>
    <h3>¿Cómo Registrar Productos?</h3>
    <br>
    <h4>Glosario:</h4>
    <ul>
      <li>Este es el formulario para registrar productos.</li>
      <li><b>Nombre Interno</b> se refiere al nombre que usa la empresa para referirse al producto.</li>
      <li><b>Descripción</b> se refiere a los detalles adicionales (presentación, nombre detallado).</li>
      <li>El <b>Precio unitario</b> es el precio del producto por unidad (kilo, litro, etc.).</li>
      <li>La <b>Clave</b> es la clave que utiliza el SAT para identificar los productos que son facturados.</li>
      <li>La <b>Unidad</b> es el nombre y clave que utiliza el SAT para identificar la unidad del producto.</li>
      <li>El <b>Objeto de Impuesto</b> aplica si el producto es un objeto de impuesto.</li>
      <li><b>IVA</b> es el Impuesto sobre Valor Agregado del producto, el <b>ISR</b> es el Impuesto Sobre la Renta y el <b>IVA RET</b> es el valor de Retención.</li>
    </ul>
    <br>
    <h4>Pasos:</h4>
    <ol>
      <li>Llenar los campos <b>Nombre Interno y Descripción</b>.</li>
      <li>Llenar el campo <b>Precio unitario</b> con un valor en número entero o redondeado a dos decimales.</li>
      <li>En el campo <b>"Escribe tu clave"</b>, escribir el nombre del producto de acuerdo al catálogo del SAT (Producto de leche y mantequilla, Queso, etc.).</li>
      <li>Hacer click sobre <b>"Selecciona una unidad"</b> para desplegar las opciones de unidad y seleccionar la unidad de tu producto.</li>
      <li>Hacer click sobre <b>"Selecciona el objeto de impuesto"</b> para desplegar las opciones y seleccionar si el producto es objeto de impuesto.</li>
      <li>Hacer click sobre <b>"Selecciona el IVA"</b> para desplegar las opciones de valores del IVA y seleccionar el correspondiente.</li>
      <li>Hacer click sobre <b>"Selecciona el ISR"</b> para desplegar las opciones de valores del ISR y seleccionar el correspondiente.</li>
      <li>Hacer click sobre <b>"Selecciona el IVA RET"</b> para desplegar las opciones de valores del IVA RET y seleccionar el correspondiente.</li>
      <li>Verificar que todos los campos están llenos.</li>
      <li>Hacer click en el botón <b>Registrar</b>.</li>
    </ol>
    <br>
    <h4>Ejemplo:</h4>
    <v-img contain max-height = "550" max-width="1000" src = "../assets/RegisterProducts.png"></v-img>
  

  </v-container>
  
</template>

<script>
export default {
  name: "DocsRegisterProducts",

  data: () => ({}),
};
</script>
